import React from 'react'
import SEOHead from '../components/shared/SEOHead'
import { getPageSEO } from '../utils/seoConfig'
import Navbar from '../components/shared/Navbar'
import ViewProfile from '../components/organization-profile/ViewProfile'

const ViewOrganizationProfilePage: React.FC = () => {
  return (
    <>
      <SEOHead seo={getPageSEO("organizationProfile")} />
      <Navbar />
      <ViewProfile />
    </>
  )
}

export default ViewOrganizationProfilePage
